const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Resolve a possibly-relative /api/files/... URL to absolute. */
export function resolveUrl(url) {
  if (!url) return url;
  return url.startsWith("/api/files/") ? `${BACKEND_URL}${url}` : url;
}
